
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.166 14.166h1.667v-5H9.166v5zm.833-12.5a8.336 8.336 0 00-8.333 8.333c0 4.6 3.733 8.334 8.333 8.334s8.334-3.734 8.334-8.334-3.734-8.333-8.334-8.333zm0 15a6.676 6.676 0 01-6.666-6.667 6.676 6.676 0 016.666-6.666 6.676 6.676 0 016.667 6.666 6.676 6.676 0 01-6.667 6.667zm-.833-9.167h1.667V5.833H9.166v1.666z","fill":"#55585E"}})])
          )
        }
      }
    